/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Stat } from './Stat';

class BuyerStat extends Stat {
    constructor() {
        super();
        this.baseUrl += '/buyerStat';
    }

    buyerOrderStatList({
        statDateDay,
        orderByType,
        minCustomerPrice,
        minOrderAmount,
        minOrderCount,
        buyerLevelId,
        distributorLevelId,
        mobile,
        currentPage,
        pageSize,
    } = {}) {
        let statBeginDate = null;
        let statEndDate = null;
        if (statDateDay != null && statDateDay.length === 2) {
            statBeginDate = statDateDay[0];
            statEndDate = statDateDay[1];
        }
        return super.get('/buyerOrderStatList', {
            statBeginDate,
            statEndDate,
            orderByType,
            minCustomerPrice,
            minOrderAmount,
            minOrderCount,
            buyerLevelId,
            distributorLevelId,
            mobile,
            currentPage,
            pageSize,
        });
    }
}

export default new BuyerStat();
export { BuyerStat };
